import script from "./CaseCont.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseCont.vue?vue&type=script&setup=true&lang=js"

import "./CaseCont.vue?vue&type=style&index=0&id=08a24eb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a24eb2"]])

export default __exports__